import React from "react";
import PageComponent from "../../components/PageComponent";
import "./InfoPage.scss";
import SectionHeader from "../../components/header/SectionHeader";

class ContactPage extends PageComponent {
  render() {
    return (
      <div className="centerSection pageSection">
        <div className="marginBottomXLarge"></div>
        <SectionHeader
          title="Contact Us."
          subtitle={
            <p>
              {" "}
              Please send all inquiries to{" "}
              <a
                className="aboutLink"
                href="mailto:hello@nextbest.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                hello@nextbest.com.
              </a>
            </p>
          }
          spacing="marginBottomXLarge"
        />
      </div>
    );
  }
}

export default ContactPage;
